import { RawTrimSpecs, TrimSpecs } from './schema/build/types';
import { parseRawValueWithUnit } from './utils';

export const parseVehicleTrim = (specs: RawTrimSpecs): TrimSpecs => {
  const { Highlights, Rating, More_Details: moreDetails } = specs;

  let specWarranty = {
    distance: { value: '', unit: '' },
    time: { value: '', unit: '' },
  };
  let batteryWarranty = {
    distance: { value: '', unit: '' },
    time: { value: '', unit: '' },
  };
  let electricMileage = {
    energy: { value: '', unit: '' },
    distance: { value: '', unit: '' },
  };

  const parseRawElectricMileage = (mileageString: string) => {
    const array = mileageString.split('/');
    const energy = array[0].split(' ');
    const distance = array[1].match(/^(\d+)(\D+)$/);
    return {
      energy: {
        value: energy[0] || '',
        unit: energy[1] || '',
      },
      distance: {
        value: distance ? distance[1] : '',
        unit: distance ? distance[2] : '',
      },
    };
  };

  const parseRawWarranty = (warrantyString: string) => {
    const array = warrantyString.split('/');
    const distance = array[1].split(' ');
    const time = array[0].split(' ');
    return {
      distance: {
        value: distance[0] || '',
        unit: distance[1] || '',
      },
      time: {
        value: time[0] || '',
        unit: time[1] || '',
      },
    };
  };

  if (moreDetails) {
    if ('Original Warranty' in moreDetails) {
      const specsWarrantyRaw = moreDetails['Original Warranty'].find(
        (warrantyItem) => warrantyItem.name === 'Basic warranty'
      );
      const tractionBatteryWarrantyRaw = moreDetails['Original Warranty'].find(
        (warrantyItem) => warrantyItem.name === 'Traction battery warranty'
      );
      if (specsWarrantyRaw) {
        specWarranty = parseRawWarranty(specsWarrantyRaw.value);
      }
      if (tractionBatteryWarrantyRaw) {
        batteryWarranty = parseRawWarranty(tractionBatteryWarrantyRaw.value);
      }
    }
    if ('Fuel Economy and Emissions' in moreDetails) {
      const electricMileageRaw = moreDetails['Fuel Economy and Emissions'].find(
        (item) => item.name === 'Electric fuel economy combined'
      );
      if (electricMileageRaw) {
        electricMileage = parseRawElectricMileage(electricMileageRaw.value);
      }
    }
  }

  return {
    moreDetails: specs?.More_Details ?? null,
    msrp: specs?.Est_MSRP ?? null,
    specWarranty,
    batteryWarranty,
    electricMileage,
    rating: Rating
      ? {
          economyRating: specs.Rating.Economy_Rating,
          familyFriendlyRating: specs.Rating.Family_Friendly_Rating,
          performanceRating: specs.Rating.Performance_Rating,
          safetyRating: specs.Rating.Safety_Rating,
          techRating: specs.Rating.Tech_Rating,
        }
      : null,
    highlights: {
      Body_Type: Highlights?.Body_Type ?? '',
      Seating_Capacity: Highlights?.Seating_Capacity ?? 0,
      DC_Charging_Time: parseRawValueWithUnit(Highlights?.DC_Charging_Time),
      Cargo_Capacity: { value: 'N/A' },
      Drive_Type: Highlights?.Drive_Type ?? '',
      Range: parseRawValueWithUnit(Highlights?.Range),
      Horsepower: parseRawValueWithUnit(Highlights?.Horsepower),
      Torque: parseRawValueWithUnit(Highlights?.Torque),
      Battery_Warranty: Highlights?.Battery_Warranty ?? '',
      Charger_Plug_Type: Highlights?.Charger_Plug_Type ?? '',
    },
  };
};
